export const ToastMessages = {
  export: {
    inProgress: 'Please wait, your file will be downloaded soon.',
    success: 'File exported successfully.',
    error: 'Failed to export file.',
  },
  preferences: {
    success: 'Preferences saved successfully!',
    error: 'Failed to save preferences. Please try again.',
  },
  session: {
    success: 'Session Name changed to ',
    error: 'Failed to update session name',
  },
  summary: {
    error: 'Failed to fetch summary details',
  },
  general: {
    error: 'Some error occurred',
  },
  settings: {
    success: 'Settings saved successfully!',
    error: 'Failed to save settings',
    inProgress: 'Applying settings to application',
  },
};
